import React from 'react';
import Navigation from 'material-ui/svg-icons/navigation/menu';
export const NavigationMenu = ({
  iconStyles
}) => /*#__PURE__*/React.createElement(Navigation, {
  style: iconStyles,
  color: "#fff"
});